export default __webpack_public_path__ + "static/media/25092701.6912febc.jpg";